import { t } from "@/i18n-js/instance";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";

interface ModalHeaderProps {
  handleClose: () => void;
}

export const ModalHeader = ({ handleClose }: ModalHeaderProps) => (
  <Modal.Header>
    <Modal.Title size="md" className="w-full text-left">
      <Typography.TitleMd weight="font-bold">
        {t("settings.ai_actions.modal.title")}
      </Typography.TitleMd>
    </Modal.Title>
    <Modal.HeaderActions className="absolute right-0 top-0 mr-6 mt-6">
      <Modal.CloseButton onClick={handleClose} />
    </Modal.HeaderActions>
  </Modal.Header>
);
